<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div class="first">
        <img :src="imageSrc(item.num)" alt="" />

        <p class="desc">{{ item.desc }}</p>

        <ul>
          <li><p>활동 시기 : {{ item.date }}</p></li>
          <li class="performance">
            <div class="li-left"><p>2025년 참여기업 :&nbsp;{{item.enterprise}}</p></div>
            <div class="third">
              <p>{{item.enterpriseList}}</p>
            </div>
          </li>
          <li><p>활동 실적 : {{ item.performance }}</p></li>
        </ul>
      </div>

      <div class="total-year-records" style="padding-top: 12px;">
        <table class="season-table">
          <thead>
          <tr>
            <td>기부처</td>
            <td>기부금</td>
            <td>기부회사</td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              나광모 <br>
              (나눔을 실천하는<br>광양사람들의 모임)
            </td>
            <td>360만원</td>
            <td>㈜ 은혜</td>
          </tr>
          <tr>
            <td>
              한국장애인문화 전라남도 협회 광양시 지부 <br>
              광양시 여성방범대
            </td>
            <td>360만원</td>
            <td>
              ㈜ 대기건설
            </td>
          </tr>
          <tr>
            <td>골약동사무소</td>
            <td>360만원</td>
            <td>㈜초록건설</td>
          </tr>
          <tr>
            <td>광양시어린이보육재단</td>
            <td>360만원</td>
            <td>㈜에이치피이앤씨</td>
          </tr>
          <tr>
            <td>희망찬특수어린이집</td>
            <td>180만원</td>
            <td>㈜한창산업</td>
          </tr>
          <tr>
            <td>초록우산</td>
            <td>360만원</td>
            <td>그러소 광양불고기</td>
          </tr>
          <tr>
            <td>광양시 여성방범대</td>
            <td>360만원</td>
            <td>㈜다원하이텍</td>
          </tr>
          <tr>
            <td>
              광양시 지체장애인협회 <br>
              광양시 마음나누리쉼터 <br>
              광양환경공사
            </td>
            <td>360만원</td>
            <td>광양시약사회</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ul style="padding-top: 12px;">
        <li>
          <div><p>문의처 : 061-815-0114</p></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrDonationChallenge',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 1,
          title: '희망 Shoot! 나눔 Goal!<br>기부챌린지',
          desc: '“희망 Shoot! 나눔 Goal! 기부챌린지”는 지역 기업/단체와 함께 따뜻한 손길이 필요한 아동, 여성, 노인 등 사회 소외계층에게 축구를 통해 꿈과 희망을 전달하고 감사 나눔을 실천하는 프로그램으로 전남드래곤즈 홈경기 시 골을 넣을 때마다 각 기업에서 10만원을 적립하여 시즌 종료 후 지역 복지재단 및 단체에 기부하는 활동입니다.',
          date: '매년 K리그2 시즌 중',
          target: '총 8개 기업',
          enterpriseList: '(주)은혜, (주)대기건설, (주)초록건설, (주)에이치피이앤씨, (주)한창산업, (주)다원하이텍, 그러소 광양불고기, 광양시약사회',
          performance: '총2,700만원'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
body {
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
  margin-bottom: 0;
}

li.performance::before {
  display: none !important;
}
.performance .li-left p::before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 2px;
  vertical-align: middle;
  margin: -2px 5px 0 0;
  background: #777777;
}

.program-page .item-div ul .performance .third {
  padding: 6px 0 0 6px !important;
}

.match-history table tbody tr td, .total-year-records table tbody tr td {
  color: #222325;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
